"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.discountAppliedPayloadSchema = exports.packageActivatedPayloadSchema = exports.tariffActivatedPayloadSchema = exports.depositSettledPayloadSchema = exports.advanceDebitedPayloadSchema = exports.advanceCreditedPayloadSchema = exports.refundProcessedPayloadSchema = exports.receiptCancelledPayloadSchema = exports.receiptIssuedPayloadSchema = exports.paymentCompletedPayloadSchema = exports.FinancialEventNames = void 0;
/**
 * Domain event names + payload schemas for the Financial Foundation
 * bounded context (Stage 5C.2). Mirrors `patient.events.ts`'s shape
 * exactly: published by Financial Application Services through the
 * enveloped Domain Event Layer (`modules/financial/_shared-event`,
 * itself a same-shape sibling of `modules/patient/_shared-event`, not
 * a shared runtime instance — see that module's own header comment
 * for why). Only events with a genuine downstream business purpose
 * are defined here — no speculative "just in case" events. Financial
 * events are deliberately a SEPARATE mechanism from `FinPostingEventLog`
 * (a durable, queryable Postgres row recording that a financial event
 * occurred and which posting rule matched it, per ADR-020) — a service
 * may do one, the other, both, or neither, per its own judgment; this
 * file/mechanism has no awareness of posting rules at all.
 */
const zod_1 = require("zod");
exports.FinancialEventNames = {
    PAYMENT_COMPLETED: 'financial.payment-completed',
    RECEIPT_ISSUED: 'financial.receipt-issued',
    RECEIPT_CANCELLED: 'financial.receipt-cancelled',
    REFUND_PROCESSED: 'financial.refund-processed',
    ADVANCE_CREDITED: 'financial.advance-credited',
    ADVANCE_DEBITED: 'financial.advance-debited',
    DEPOSIT_SETTLED: 'financial.deposit-settled',
    TARIFF_ACTIVATED: 'financial.tariff-activated',
    PACKAGE_ACTIVATED: 'financial.package-activated',
    DISCOUNT_APPLIED: 'financial.discount-applied',
};
exports.paymentCompletedPayloadSchema = zod_1.z.object({
    tenantId: zod_1.z.string().uuid(),
    paymentId: zod_1.z.string().uuid(),
    paymentNumber: zod_1.z.string(),
    transactionType: zod_1.z.string(),
    totalAmount: zod_1.z.number().int(),
    patientId: zod_1.z.string().uuid().nullable(),
});
exports.receiptIssuedPayloadSchema = zod_1.z.object({
    tenantId: zod_1.z.string().uuid(),
    receiptId: zod_1.z.string().uuid(),
    receiptNumber: zod_1.z.string(),
    paymentId: zod_1.z.string().uuid(),
});
exports.receiptCancelledPayloadSchema = zod_1.z.object({
    tenantId: zod_1.z.string().uuid(),
    receiptId: zod_1.z.string().uuid(),
    reasonCode: zod_1.z.string().nullable(),
});
exports.refundProcessedPayloadSchema = zod_1.z.object({
    tenantId: zod_1.z.string().uuid(),
    refundPaymentId: zod_1.z.string().uuid(),
    originalReceiptId: zod_1.z.string().uuid(),
    amount: zod_1.z.number().int(),
});
exports.advanceCreditedPayloadSchema = zod_1.z.object({
    tenantId: zod_1.z.string().uuid(),
    accountId: zod_1.z.string().uuid(),
    transactionId: zod_1.z.string().uuid(),
    amount: zod_1.z.number().int(),
    balanceAfter: zod_1.z.number().int(),
});
exports.advanceDebitedPayloadSchema = zod_1.z.object({
    tenantId: zod_1.z.string().uuid(),
    accountId: zod_1.z.string().uuid(),
    transactionId: zod_1.z.string().uuid(),
    amount: zod_1.z.number().int(),
    balanceAfter: zod_1.z.number().int(),
});
exports.depositSettledPayloadSchema = zod_1.z.object({
    tenantId: zod_1.z.string().uuid(),
    accountId: zod_1.z.string().uuid(),
    transactionId: zod_1.z.string().uuid(),
    settledAmount: zod_1.z.number().int(),
});
exports.tariffActivatedPayloadSchema = zod_1.z.object({
    tenantId: zod_1.z.string().uuid(),
    tariffId: zod_1.z.string().uuid(),
    tariffCode: zod_1.z.string(),
    versionNumber: zod_1.z.number().int(),
});
exports.packageActivatedPayloadSchema = zod_1.z.object({
    tenantId: zod_1.z.string().uuid(),
    packageId: zod_1.z.string().uuid(),
    versionNumber: zod_1.z.number().int(),
});
exports.discountAppliedPayloadSchema = zod_1.z.object({
    tenantId: zod_1.z.string().uuid(),
    discountRuleId: zod_1.z.string().uuid(),
    sourceEntityType: zod_1.z.string(),
    sourceEntityId: zod_1.z.string().uuid(),
    discountAmount: zod_1.z.number().int(),
});
//# sourceMappingURL=financial.events.js.map